<script>
  import Product from "./Product.svelte";
  export let section;
  export let gallery;
</script>
<div class="section" key={section.key}>
  <h2>{section.category}</h2>
  <div class="products">
    {#each section.products as product}
      <Product product={product} gallery={gallery} />
    {/each}
  </div>
</div>
<style>
  h2 {
    max-width: 960px;
    padding: 0 20px;
    margin: 0 auto;
    text-transform: uppercase;
    font-family: "Open Sans", sans-serif;
    font-weight: 500;
    color: #003DA6;
  }
  .products {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    max-width: 1000px;
    margin: 0 auto;
    padding-bottom: 80px;
  }
  @media screen and (min-width: 1400px) {
    h2 {
      font-size: 150%;
      line-height: 150%;
    }
  }
</style>
